var pickYourCountry = 'https://bioeffect.com/pages/pick-your-country';
var ipInfo = 'https://ipinfo.io';
var homePage = 'https://bioeffect.com/';
var bioEffectIndex = "https://www.bioeffect.com/index";

$(document).ready(function() {
  $('[data-toggle=readmore]').click(function() {
  	var target = $(this).data('target');
    var text = $(this).text();
    
    $('[data-readmore='+target+']').toggleClass('expanded');
    if ( text == 'Read More +' ) $(this).text('Read Less -');
    else $(this).text('Read More +');
  });
  
  if (window.location.href.indexOf("pick-your-country") > -1) {
    $(".preheader, .footer-bar, footer, ul.nav.navbar-nav.navbar-center.text-xs.text-lowercase, form.navbar-form.navbar-right.hidden-xs, .nav-more, ul.nav.navbar-nav.navbar-right.text-sm, .navbar-nav").hide();
    $("a.navbar-brand").attr("href", bioEffectIndex);
  }
  
  if (window.location.href.indexOf("/index") > -1) {
    $("a.navbar-brand").attr("href", bioEffectIndex);
  }
  
  $(".country-link").click(function(){
    // create cookie based on their country of choice via click
    createCookie("countryPage", $(this).attr('href'), 30);
  })
  
  // Conditional to redirect users based on country picked using cookies
  
  if(window.location.pathname === "/" && readCookie("countryPage") === bioEffectIndex){
    // cookie exists and leads to index
    window.location.replace(bioEffectIndex)
  } else if (window.location.pathname === "/" && document.cookie.indexOf("countryPage") >=0 ) {
//     cookie exists and will redirect to respective site
    window.location.replace(readCookie("countryPage"))
  } else if (window.location.pathname === "/") {
    console.log('HERE');
    // fresh user; no cookies and will redirect if customer is international
//     intlRedirect();
  }
  
	// whiteFader();
  
//Greenhouse page onclick scroll to bokun widgte
  $('#book-order-btn').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('#bokun-widget').offset().top - 100
    }, 1000);
  });
});

//Pick your country show
$('.pick-your-country-link').on('click', function(e) {
  e.preventDefault();
  $('.section-pick-your-country').toggleClass('active');
});
$('.section-pick-your-country .close-icon').on('click', function(e) {
  $('.section-pick-your-country').removeClass('active');
});

// Creating a cookie

function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name,"",-1);
}

// Redirect for international customers

function intlRedirect() {  
  $.getJSON(ipInfo, function(data) {
//     PICK YOUR COUNTRY PAGE DISABLED AS PER REQUIREDMENT
//     YOU CAN ENABLE BY UNCOMMENT THE FOLLOWING CODE
    
//      if (window.location.href === homePage && data.country != 'US'){
// //       // whiteOverlay();
//        window.location.replace(pickYourCountry)
//      }
    
//     if (data.country != 'US') {
//       $("a.navbar-brand").attr("href", "http://bioeffect.com/index");
//     }
  });
}

$(window).load(function() {
    $('#container1').twentytwenty();
  	$('#container2').twentytwenty();
});